import React, {
  forwardRef,
  Fragment,
  useEffect,
  useImperativeHandle,
  useState,
} from "react";
import { connect, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import "./collapsBlock.scss";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import CloseIcon from "@mui/icons-material/Close";
import {
  getDeterminants,
  initiateGoals,
  newTest,
  setUserData,
  withdrawGoals,
} from "../../redux/action/user";
import Skeleton from "@mui/material/Skeleton";
import {
  Box,
  Button,
  Chip,
  InputLabel,
  LinearProgress,
  Modal,
  Stack,
  Tooltip,
} from "@mui/material";

import SnackBar from "../snackBar";
import WarningIcon from '@mui/icons-material/Warning';
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import { isSubscriptionActive } from "../../common";

const CollapsBlock = forwardRef((props, ref) => {
  const [showDeleteButton, setShowDeleteButton] = useState(false);
  const [updatedData, setUpdatedData] = useState(props.data);
  const [expandedList, setExpandedList] = useState([]);
  const [goal, setGoal] = useState([]);
  const [completed, setCompleted] = useState([]); // Track completed suggestions
  const [showWarningRemove, setShowWarningRemove] = useState(false);
  const [showWarningValidate, setShowWarningValidate] = useState(false);
  const [openSnackBar, setOpenSnackBar] = useState(false);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [warning, setWarning] = useState({
    text: "Stay focused - max 5 goals at a time.",
    type: "limit",
  });
  const [errorMessage, setErrorMessage] = useState("");
  const isCurrentSurvey =
    props.user.surveyIdList &&
    props.user.surveyIdList?.length - 1 == localStorage.getItem("assesmentKey");
  // const [lowestScoreSuggestionId, setLowestScoreSuggestionId] = useState([]);

  const isSubscription = isSubscriptionActive(props?.user)


  const Resume =
    (props.user.surveyIdList &&
      props.user.surveyIdList.length > 0 &&
      props.user.surveyIdList[props.user.surveyIdList.length - 1]
        .s_IsSurveyCompleted !== 1) ||
    false;
  const navigate = useNavigate();
  const dispatch = useDispatch();


  useEffect(() => {
    if (props.data && props.data.length > 0) {
      setExpandedList((prev) => {
        if (prev.length === 0) {
          // If it's the first render, open the first accordion
          return [props.data[0].ID];
        }
        // Preserve the previously expanded accordions
        const newExpandedList = new Set(prev);
        props.data.forEach((item) => {
          if (newExpandedList.has(item.ID)) {
            newExpandedList.add(item.ID);
          }
        });
        return Array.from(newExpandedList);
      });

      const progressNot100 = getSuggestionsWithProgress(props.data);
      const progress100 = getSuggestionsWithCompelted(props.data);
      setGoal(progressNot100);
      setCompleted(progress100);
      setUpdatedData(props.data)
    }
  }, [props.data]);




  useEffect(() => {
    const host = window.location.host;
    if (
      host === "localhost:3000" ||
      host.search("demo") !== -1 ||
      props.deleteVisible
    ) {
      setShowDeleteButton(true);
    }
  }, []);

  useEffect(() => { }, [isSubscription]);

  useEffect(() => {
    if (props.user?.error.errormsg) {
      setErrorMessage(props.user?.error.errormsg);
    }
  }, [props.user?.error.errormsg]);

  useEffect(() => {
    if (errorMessage) {
      setOpenSnackBar(true);
    }
  }, [errorMessage]);


  const getSuggestionsWithProgress = (suggestions) => {
    return suggestions?.flatMap((item) => {
      const suggestionArray = Array.isArray(item?.suggestion) ? item.suggestion : [];
      return suggestionArray
        ?.filter((s) => s?.progress !== 100 && s?.progress !== null)
        ?.map((s) => s.suggestionID);
    });
  };

  const getSuggestionsWithCompelted = (suggestions) => {
    return suggestions?.flatMap((item) => {
      const suggestionArray = Array.isArray(item?.suggestion) ? item.suggestion : [];
      return suggestionArray
        ?.filter((s) => s?.progress === 100)
        ?.map((s) => s.suggestionID);
    });
  };

  const withdrawGoal = async () => {
    if (warning.data) {
      setShowWarningRemove(false);
      const res = await props.withdrawGoals(warning.data);
      if (res === 200) {
        setGoal(goal.filter((id) => id !== warning.data?.suggestionID));
        await props.getDeterminants();
      }
    }
  };

  const handleGoals = async (val, status) => {
    if (!isSubscription) return;
    const data = {
      UserID: localStorage.getItem("userKey"),
      suggestionID: val.suggestionID,
      assessmentID: localStorage.getItem("assesmentKey"),
    };
    if (status === "remove") {
      setShowWarningRemove(true);
      setWarning({
        text: "Are you sure you want to reset the Goal progress?",
        type: "confirm",
        data: data,
      });
    } else {

      if (goal.length >= 5) {
        setShowWarningValidate(true); // Show warning if the user has already set 5 goals
        setWarning({
          text: "Stay focused - max 5 goals at a time.",
          type: "limit",
        });
      } else if (
        !completed.includes(val.suggestionID)
      ) {
        const res = await props.initiateGoals(data);
        if (res === 200) {
          const newGoalList = [...goal, val.suggestionID];
          setGoal(newGoalList);
          await props.getDeterminants().then((resp1) => {
            // Open modal on success response
            if (props.modelOpen) {
              const newDeterminObj = resp1.find((el) => el.ID == val.determinId)
              if (newDeterminObj) {
                const newSuggObj = newDeterminObj?.suggestion?.find((el) => el?.suggestionID == val?.suggestionID)
                if (newSuggObj) {
                  const goalStatus = getGoalStatus(newSuggObj, newGoalList);
                  const suggestionObjRef = {
                    ...newSuggObj,
                    goalstatus: goalStatus,
                  };
                  props.modelOpen(suggestionObjRef);
                }
              }
            }
          })
        }
      }
    }
  };

  useImperativeHandle(ref, () => ({
    handleGoalsCancel: (val, status) => handleGoals(val, status),
    startNewAssessment: () =>
      !Resume && isSubscription ? setShowConfirmModal(true) : newAssessment(),
  }));

  const getGoalStatus = (suggestionObj, currentGoalList = goal) => {
    if (!isCurrentSurvey) {
      if (completed.includes(suggestionObj.suggestionID)) {
        return {
          color: "#709640",
          showProgress: false,
          icon: "completed-icon",
          statusClass: "complete",
        };
      } else {
        return {
          color: "#ffd781",
          showProgress: false,
          icon: "archived-icon",
          statusClass: "archived",
        };
      }
    } else if (currentGoalList.includes(suggestionObj.suggestionID)) {
      return {
        color: "khaki",
        showProgress: true,
        icon: "in-progress-icon",
        statusClass: "cancel",
      };
    } else if (completed.includes(suggestionObj.suggestionID)) {
      return {
        color: "greenyellow",
        showProgress: false,
        icon: "completed-icon",
        statusClass: "complete",
      };
    } else {
      return {
        color: "",
        showProgress: false,
        icon: "default-icon",
        statusClass: "add",
      };
    }
  };

  const newAssessment = async () => {
    if (Resume) {
      localStorage.removeItem("progressDone");
      localStorage.removeItem("detailDone");
      localStorage.setItem(
        "assesmentKey",
        props.user.surveyIdList[props.user.surveyIdList.length - 1].SurveyId
      );
      dispatch(
        setUserData({
          surveyId:
            props.user.surveyIdList[props.user.surveyIdList.length - 1]
              .SurveyId,
        })
      );
      navigate("/progress");
    } else {
      await props.newTest(props.user._id, navigate);
    }
  };

  const formatScore = (score) => {
    const n = parseInt(score, 10);
    if (!Number.isFinite(n)) return "00";
    return String(Math.max(0, n)).padStart(2, "0");
  };

  const suggestionCopy = (suggestionObj) => {
    const raw = String(suggestionObj?.Suggestion || "").trim();
    const dash = raw.indexOf(" - ");
    if (dash > 0) {
      return {
        title: raw.slice(0, dash).trim(),
        subtitle: raw.slice(dash + 3).trim() || String(suggestionObj?.Blurb || "").trim(),
      };
    }
    return {
      title: raw,
      subtitle: String(suggestionObj?.Blurb || "").trim(),
    };
  };

  const goToMemberships = () => navigate("/plans");

  return (
    <div className={`assessment-journey${isSubscription ? "" : " is-free-plan"}`}>
      <div className="focus-header">
        <div className="focus-header__copy">
          <p className="focus-kicker">
            {isSubscription
              ? "Where to focus first"
              : "Your two lowest determinants"}
          </p>
          <h2 className="focus-title">
            {isSubscription ? "Choose up to five goals" : "Start here"}
          </h2>
        </div>
        {isSubscription ? (
          <div className="focus-meter" aria-label={`${goal.length} of 5 goals active`}>
            <div className="focus-meter__ticks">
              {[0, 1, 2, 3, 4].map((i) => (
                <span
                  key={i}
                  className={`focus-meter__tick${i < goal.length ? " is-active" : ""}`}
                />
              ))}
            </div>
            <span className="focus-meter__label">
              {goal.length} of 5 goals active
            </span>
          </div>
        ) : null}
      </div>
      {!isSubscription ? (
        <div className="goals-members-strip">
          <p>
            Goals are for members. Unlock all ten determinants, set up to five
            goals, and track your progress.
          </p>
          <button type="button" onClick={goToMemberships}>
            Become a member
          </button>
        </div>
      ) : null}
      <div className="inner-bg-result">
        {!isCurrentSurvey && isSubscription && (
          <Box className="focus-legend">
            <Typography>Archived</Typography>
            <Typography>Completed</Typography>
          </Box>
        )}
        <div className="determinant-list">
          {props.data &&
            props.data.map((obj, index) => {
              const isLockedFree = !isSubscription && index >= 2;
              const isRecommended =
                (isSubscription && isCurrentSurvey && index < 4) ||
                (!isSubscription && index < 2);
              return (
                <Accordion
                  expanded={expandedList.includes(obj.ID)}
                  key={obj.ID}
                  className={`determinant-row${isLockedFree ? " is-locked" : ""}`}
                  disableGutters
                >
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls={`panel-${obj.ID}-content`}
                    id={`panel-${obj.ID}-header`}
                    onClick={() => {
                      setExpandedList((prev) => {
                        const temp = new Set(prev);
                        if (temp.has(obj.ID)) {
                          temp.delete(obj.ID);
                        } else {
                          temp.add(obj.ID);
                        }
                        return Array.from(temp);
                      });
                    }}
                  >
                    <div className="determinant-summary">
                      <span className="determinant-score">
                        {isLockedFree ? (
                          <LockOutlinedIcon fontSize="inherit" aria-label="Locked" />
                        ) : (
                          formatScore(obj.score)
                        )}
                      </span>
                      <span className="determinant-name">{obj.Determinant}</span>
                      {isRecommended ? (
                        <span className="recommended-tag">Recommended</span>
                      ) : null}
                    </div>
                  </AccordionSummary>
                  <AccordionDetails>
                    {isLockedFree ? (
                      <div className="locked-determinant-panel">
                        <p>
                          To reveal all your suggestions, goal setting and access
                          to the community, become a member.
                        </p>
                        <button type="button" onClick={goToMemberships}>
                          Become a member
                        </button>
                      </div>
                    ) : obj.isGetSuggestion ? (
                      <>
                        <Box className="suggestion-listing">
                          <ul>
                            {obj.suggestion && obj.suggestion.length > 0 ? (
                              obj.suggestion.map((suggestionObj, subIndex) => {
                                const goalStatus = getGoalStatus(suggestionObj);
                                const suggestionObjRef = {
                                  ...suggestionObj,
                                  DeterminantName: obj.Determinant,
                                  goalstatus: goalStatus,
                                };
                                const copy = suggestionCopy(suggestionObj);
                                return (
                                  <li
                                    key={suggestionObj.suggestionID || subIndex}
                                    className={
                                      isSubscription &&
                                      isCurrentSurvey &&
                                      goalStatus.statusClass
                                    }
                                  >
                                    <span className="suggestion-index">
                                      {String(subIndex + 1).padStart(2, "0")}
                                    </span>
                                    <Box className="ContentWrap">
                                      <button
                                        type="button"
                                        className="suggestion-copy"
                                        onClick={() => {
                                          if (isSubscription && props.modelOpen) {
                                            props.modelOpen(suggestionObjRef);
                                          }
                                        }}
                                      >
                                        <span className="suggestion-title">
                                          {copy.title}
                                        </span>
                                        {copy.subtitle ? (
                                          <span className="suggestion-subtitle">
                                            {copy.subtitle}
                                          </span>
                                        ) : null}
                                      </button>

                                      {!isSubscription ? (
                                        <span className="members-only-label">
                                          <LockOutlinedIcon fontSize="inherit" />
                                          Members only
                                        </span>
                                      ) : isCurrentSurvey ? (
                                        <Tooltip
                                          title={
                                            goalStatus.icon === "completed-icon"
                                              ? "Completed Goal"
                                              : goalStatus.icon === "in-progress-icon"
                                                ? "Remove Goal"
                                                : "Click to add goal"
                                          }
                                        >
                                          {goalStatus.icon === "completed-icon" ? (
                                            <Chip
                                              color="success"
                                              label="Completed"
                                              onClick={() => console.log("")}
                                            />
                                          ) : goalStatus.icon === "in-progress-icon" ? (
                                            <></>
                                          ) : (
                                            <button
                                              type="button"
                                              className="add-goal-btn"
                                              onClick={() =>
                                                handleGoals(suggestionObj, "add")
                                              }
                                            >
                                              Add Goal
                                            </button>
                                          )}
                                        </Tooltip>
                                      ) : null}
                                      {isSubscription &&
                                        goalStatus.showProgress && (
                                          <Stack spacing={2} sx={{ flex: 1 }}>
                                            <Box
                                              sx={{
                                                display: "flex",
                                                alignItems: "center",
                                              }}
                                            >
                                              <Box sx={{ width: "100%", mr: 1 }}>
                                                <LinearProgress
                                                  variant="determinate"
                                                  value={suggestionObj.progress || 0}
                                                />
                                              </Box>
                                              <Box
                                                sx={{ minWidth: 35 }}
                                                className="progresspercent"
                                              >
                                                <Typography
                                                  variant="body2"
                                                  sx={{ color: "text.secondary" }}
                                                >
                                                  {`${Math.floor(
                                                    suggestionObj.progress || 0
                                                  )}%`}
                                                </Typography>
                                              </Box>
                                            </Box>
                                          </Stack>
                                        )}
                                    </Box>
                                  </li>
                                );
                              })
                            ) : (
                              <Fragment>
                                <div className="yellow-font tooltip-title">
                                  <Skeleton
                                    variant="text"
                                    width="100%"
                                    height={20}
                                    sx={{ backgroundColor: "aliceblue" }}
                                  />
                                </div>
                                <ul>
                                  <Skeleton
                                    variant="text"
                                    width="100%"
                                    height={20}
                                    sx={{ backgroundColor: "aliceblue" }}
                                  />
                                </ul>
                                <ul>
                                  <Skeleton
                                    variant="text"
                                    width="100%"
                                    height={20}
                                    sx={{ backgroundColor: "aliceblue" }}
                                  />
                                </ul>
                                <ul>
                                  <Skeleton
                                    variant="text"
                                    width="100%"
                                    height={20}
                                    sx={{ backgroundColor: "aliceblue" }}
                                  />
                                </ul>
                                <ul>
                                  <Skeleton
                                    variant="text"
                                    width="100%"
                                    height={20}
                                    sx={{ backgroundColor: "aliceblue" }}
                                  />
                                </ul>
                                <InputLabel
                                  className="member-reveal"
                                  style={{
                                    cursor: "pointer",
                                    padding: "10px 0 16px",
                                    textDecoration: "underline",
                                    color: "#c9a227",
                                  }}
                                  onClick={() => navigate("/plans")}
                                >
                                  To reveal all your suggestions, become a
                                  member here!
                                </InputLabel>
                              </Fragment>
                            )}
                          </ul>
                        </Box>
                      </>
                    ) : (
                      <ul>
                        <p className="cus-label" style={{ color: "#1c2424", padding: "16px 20px" }}>{obj.suggestion}</p>
                      </ul>
                    )}
                  </AccordionDetails>
                </Accordion>
              );
            })}
        </div>
      </div>
      <Modal
        open={showWarningRemove}
        onClose={() => setShowWarningRemove(false)}
      >
        <Box sx={modalStyle} width={"40%"} minWidth={'400px'} maxWidth={'600px'}>
          <div className="close-pop-wrap">
            <Box className="Heading">
              <Typography
                variant="h6"
                sx={{ fontWeight: "bold", color: "#fff", display: 'flex', alignItems: 'center' }}
              >
                <WarningIcon color="warning" />
                Warning
              </Typography>
            </Box>
            <CloseIcon
              onClick={() => setShowWarningRemove(false)}
              className="CloseImg"
            />
          </div>
          <div className="ContentWrapper">
            Dropping this goal will set its progress to 0%. Are you sure you
            want to drop this goal ?{" "}
          </div>

          {/* Modal Actions */}
          <Box className="modal-actions" display="flex" justifyContent="end" mt={2} marginRight={2}>
            <Button
              variant="contained"
              sx={{
                fontWeight: "bold",
                fontSize: "16px",
                marginRight: 2,
                background: '#E29C2E',
                '&:hover': {
                  background: '#C07D1A'
                }
              }}
              onClick={() => withdrawGoal()}
            >
              Yes
            </Button>
            <Button variant="outlined" color="secondary" onClick={() => setShowWarningRemove(false)} >
              No
            </Button>
          </Box>
        </Box>
      </Modal>
      <Modal
        open={showWarningValidate}
        onClose={() => setShowWarningValidate(false)}
      >
        <Box sx={modalStyle} width={"25%"} maxWidth={'400px'} minWidth={"300px"}>
          <div className="close-pop-wrap">
            <Box className="Heading">
              {/* <WraningIcon /> */}
              <Typography
                variant="h6"
                component="h2"
                sx={{ marginBottom: 2, fontWeight: "bold", color: "#d32f2f" }}
              >
                Limit Reached
              </Typography>
            </Box>
            <CloseIcon
              onClick={() => setShowWarningValidate(false)}
              className="CloseImg"
            />
          </div>
          <div className="ContentWrapper">
            Stay focused - max 5 goals at a time!
          </div>
        </Box>
      </Modal>
      {/* Show modal before starting new assessment  */}
      <Modal
        open={showConfirmModal}
        onClose={() => setShowConfirmModal(false)}
      >
        <Box sx={modalStyle} width={"45%"} maxWidth={"600px"} minWidth={"350px"}>
          {/* Modal Header */}
          <box className="close-pop-wrap" >
            <Box className="Heading">
              <Typography
                variant="h6"
                sx={{ fontWeight: "bold", color: "#fff", display: 'flex', alignItems: 'center' }}
              >
                <WarningIcon color="warning" />
                Warning
              </Typography>
            </Box>
            <CloseIcon onClick={() => setShowConfirmModal(false)} className="CloseImg" />
          </box>

          {/* Modal Body */}
          <div className="ContentWrapper">
            <Typography sx={{ textAlign: 'justify' }}>
              Are you sure? You will lose progress on your current goals and
              receive a refreshed plan. We recommend completing your original
              lessons first to maximize your experience. Would you like to
              continue?
            </Typography>
          </div>

          {/* Modal Actions */}
          <Box className="modal-actions" display="flex" justifyContent="end" mt={2} marginRight={2}>
            <Button
              variant="contained"
              sx={{
                fontWeight: "bold",
                fontSize: "16px",
                marginRight: 2,
                background: '#E29C2E',
                '&:hover': {
                  background: '#C07D1A'
                }
              }}
              onClick={() => newAssessment()}
            >
              Yes
            </Button>
            <Button variant="outlined" color="secondary" onClick={() => setShowConfirmModal(false)} >
              No
            </Button>
          </Box>
        </Box>
      </Modal>
      <SnackBar
        open={openSnackBar}
        message={errorMessage}
        handleCloseSnackBar={() => {
          setOpenSnackBar(false);
          setErrorMessage("");
        }}
      />
    </div>
  );
});

CollapsBlock.propTypes = {};
CollapsBlock.defaultProps = {};

const actionCreators = {
  newTest,
  setUserData,
  initiateGoals,
  getDeterminants,
  withdrawGoals,
};

export default connect(
  ({ user }) => ({
    user,
  }),
  actionCreators,
  null,
  { forwardRef: true }
)(CollapsBlock);

const modalStyle = {
  overflow: "hidden",
  position: "relative",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  maxHeight: "90vh",
  backgroundColor: "white",
  boxShadow: 24,
  pb: 2,
  // padding: "20px",
  // overflowY: "auto", // Makes the content scrollable
  borderRadius: "8px",
  ".close-pop-wrap": {
    top: "0px",
    right: "0px",
    position: "sticky",
    padding: "10px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    backgroundColor: "#112225",
    img: {
      width: "24px",
      height: "24px",
    },
  },
  ".Heading": {
    display: "flex",
    alignItems: "center",
    h2: {
      mb: 0,
      color: "#fff",
    },
    svg: {
      mr: 1,
      width: "20px",
      height: "20px",
      // def:{
      //   fill:"#fff"
      // },
      // path: {
      //   fill: "#d32f2f",
      // },
    },
  },
  ".CloseImg": {
    opacity: 1,
    borderRadius: "50%",
    p: "2px",
    border: "1px solid #fff",
    fontSize: "0.7rem",
    path: {
      fill: "#fff",
    },
  },
  ".ContentWrapper": {
    p: 2,
  },
};
